import { QA_ATTEMPTS, StartedAttempt } from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import {
  PostQaAttemptError,
  PostQaAttemptVariables,
  fetchPostQaAttempt,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = QA_ATTEMPTS.POST;

export const usePostQaAttempt = (
  options?: Omit<
    UseMutationOptions<StartedAttempt, PostQaAttemptError, PostQaAttemptVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<StartedAttempt, PostQaAttemptError, PostQaAttemptVariables>({
    mutationFn: (variables: PostQaAttemptVariables) =>
      fetchPostQaAttempt({
        ...fetcherOptions,
        ...variables,
        body: API_SCHEMA.REQUEST.BODY.parse(variables.body),
      }).then((r) => API_SCHEMA.RESPONSE.parse(r)),
    ...options,
  });
};
